import { buildIsServiceFn } from '../../utils';

import { SERVICE_TYPES_REGULATED } from '../../constants';

const isRegulatedService = buildIsServiceFn(SERVICE_TYPES_REGULATED);

export default isRegulatedService;
